import { QuizQuestion } from '@monoimin/sb-types';

export const portugalD7QuizDict = {
  en: {
    title: 'Portugal D7 Visa - Immigrant Invest',
    description:
      'Discover Portugal with the D7 Visa through Immigrant Invest. Ideal for passive income earners & retirees, offering residency & a path to citizenship. Explore now!',
  },
  ru: {
    title: 'Португалия D7 Виза - Immigrant Invest',
    description:
      'Откройте для себя Португалию с визой D7 через МОЮ КОМПАНИЮ. Идеально подходит для получателей пассивного дохода и пенсионеров, предлагая резидентство и путь к гражданству. Исследуйте сейчас!',
  },
};

export const portugalD7QuizQuestionsEn: QuizQuestion[] = [
  {
    question:
      'Do you have sources of stable passive income* to support yourself?',
    id: 1,
    answers: [
      {
        id: 1,
        text: 'Yes',
        image: '/images/quiz/cocktail.png',
        correct: true,
      },
      {
        id: 2,
        text: 'No',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
    ],
  },
  {
    question: 'Does your passive income exceed €10,440 a year?',
    id: 2,
    answers: [
      {
        id: 1,
        text: 'Yes',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 2,
        text: 'No',
        image: '/images/quiz/coins.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Are you ready to relocate to Portugal and spend more than 8 months a year in the country?',
    id: 3,
    answers: [
      {
        id: 1,
        text: 'Yes',
        image: '/images/quiz/bus.png',
        correct: true,
      },
      {
        id: 2,

        text: 'No',
        image: '/images/quiz/bag.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Do you plan to get Portugal D7 Visas and residence permits with your family?',
    id: 4,
    answers: [
      {
        id: 1,

        text: 'Yes',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        correct: true,
        text: 'No',
        image: '/images/quiz/person.png',
      },
    ],
  },
  {
    question: 'When can you start obtaining a Portugal D7 Visa?',
    id: 5,
    answers: [
      {
        id: 1,
        correct: true,
        text: 'Now',
        image: '/images/quiz/plane.png',
      },
      {
        id: 2,
        text: 'In 1-3 months',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: 'In 3-6 months',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: 'In 6+ months',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
];

export const portugalD7QuizQuestionsRu: QuizQuestion[] = [
  {
    question: 'Есть ли у вас источники пассивного дохода?',
    id: 1,
    tooltip:
      'Например, от сдачи недвижимости в аренду, дивиденды, роялти или пенсионные выплаты',
    answers: [
      {
        id: 1,
        text: 'Да',
        image: '/images/quiz/cocktail.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
    ],
  },
  {
    question: 'Ваш пассивный доход превышает 10440 € в год?',
    id: 2,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/coins.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Готовы ли вы переехать в Португалию и проводить в стране более 8 месяцев в году?',
    id: 3,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/bus.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/bag.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Сможете ли вы лично подать заявление на визу D7 и приехать в Португалию, чтобы открыть банковский счет?',
    id: 4,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/cyberhead.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/x.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Планируете ли вы получить визу D7 и ВНЖ в Португалии вместе с семьей?',
    id: 5,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/person.png',
        correct: true,
      },
    ],
  },
  {
    question:
      'Когда вы готовы подготовить документы и получить визу D7 в Португалию?',
    id: 6,
    answers: [
      {
        id: 1,

        text: 'Сейчас',
        image: '/images/quiz/plane.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Через 1-3 месяца',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: 'Через 3-6 месяцев',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: 'Через 6+ месяцев',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
];

export const portugalD7QuizQuestions = {
  en: portugalD7QuizQuestionsEn,
  ru: portugalD7QuizQuestionsRu,
};

export const portugalD7QuizCountryQuestion = {
  en: 'What citizenship do you hold?',
  ru: 'Ваше гражданство:',
};
